module.exports = __webpack_public_path__ + "img/spinner-third.9f8ebab0.svg";